import { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import Dropdown from "@shared/v2/Dropdown";
import { Search as SearchIcon } from "../../shared/v2/Icomoon";
import { useDebounce } from "../../shared/hookHelpers";

const searchAccounts = (search, signal) =>
  axios.get("/accounts/search", {
    signal,
    params: { search },
    headers: {
      "X-CSRF-Token": ReactOnRails.authenticityToken(),
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });

const TaskFor = ({ id, onChange, taskFor, isAppointment }) => {
  const isAppointmentRef = useRef(isAppointment);
  const [value, setValue] = useState(taskFor ? { ...taskFor, value: taskFor.uuid } : null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [_search, setSearch] = useState("");
  const search = useDebounce(_search, 250);

  useEffect(() => {
    if (search.length < 3) return () => {};
    setLoading(true);
    const abortController = new AbortController();
    searchAccounts(search, abortController.signal)
      .then((res) => {
        setLoading(false);
        setData(
          res.data
            .filter((d) => !["archived", "trash"].includes(d.status))
            .filter((d) => !isAppointment || d.object_type === "Person")
            .map((d) => ({ ...d, value: d.uuid })),
        );
      })
      .catch(() => setLoading(false));
    return () => abortController.abort();
  }, [search]);

  useEffect(() => {
    onChange(value || {});
  }, [value]);

  useEffect(() => {
    if (isAppointmentRef.current !== isAppointment) {
      setValue(null);
      setData([]);
      setSearch("");
    }
    isAppointmentRef.current = isAppointment;
  }, [isAppointment]);

  return (
    <Dropdown
      id={id}
      name="search_query"
      containerClassName="tw-flex-1"
      label={isAppointment ? "Select person" : "Select person, transaction or project"}
      placeholder="Search by Name, Email, or Address"
      isRequired
      isSearchable
      isLoading={loading}
      onInputChange={setSearch}
      getOptionLabel={(option) => (
        <>
          <i className={`${option.icon} ${option.color} task-result-icon`} /> {option.label} ({option.type})
        </>
      )}
      noOptionsMessage={
        _search.length < 3 ? `Enter ${3 - _search.length} more characters to search` : "No Options"
      }
      onChange={setValue}
      value={value}
      options={data}
      menuShouldComeToFront
      shouldFilterOptions={false}
      inputTrailing={<SearchIcon size="l" style={{ verticalAlign: "middle" }} />}
    />
  );
};

TaskFor.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  isAppointment: PropTypes.bool,
  taskFor: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
  }),
};

TaskFor.defaultProps = {
  taskFor: null,
  isAppointment: false,
};

export default TaskFor;
